/**
 * Default ESM entry point.
 *
 * Loaded via <script type="module" defer> alongside the legacy app.min.js
 * bundle. Registers custom elements and bootstraps ESM-converted modules.
 *
 * Custom elements self-upgrade via connectedCallback when the browser
 * encounters their tag; no init() call is required here. Each import
 * below runs its side-effectful customElements.define() at evaluation
 * time.
 *
 * Imports reference the BUILT output names (e.g. './expandable-list.js'),
 * not the source path (theme/js/components/expandable-list.esm.js).
 * Grunt's copy:esm task flattens the source tree into .build/assets/ and
 * strips the .esm suffix, so every file ends up siblings at runtime.
 *
 * AI: Entirely written by AI
 * Date: 2026-04-24
 * Model: Claude Opus 4.7
 * Updated: 2026-05-02 (Claude Sonnet 4.6) - Phase 8: init Turbo router
 * Updated: 2026-05-07 (Claude Sonnet 4.6) - Phase 11: header-nav, collection-list ESM
 * Updated: 2026-05-07 (Claude Opus 4.7) - Phase 12: cart-fetch, cart-state, cart-items, cart-icon-bubble, cart-drawer, line-item
 * Updated: 2026-05-07 (Claude Sonnet 4.6) - Phase 12.2: sections, overlay core modules
 */

import { log } from './log.js';
import { init as initRouter } from './router.js';
import * as consent from './consent.js';
import './application.js';
import './ep-shopify-api.js';
import './ep-shopify_common.js';
import './3sixteen-api.js';
import './notifier.js';
import './ajax-router.js';
import './sale-policy.js';
import './hemming.js';
import './forms.js';
import './maps.js';
import './currency-picker.js';
import './expandable-list.js';
import './nav-panel.js';
import './video-players.js';
import './image-slider.js';
import './newsletter-subscribe.js';
import './cart-fetch.js';
import './cart-state.js';
import './add-item-form.js';
import './product-card.js';
import './header-nav.js';
import './collection-list.js';
import './cart-items.js';
import './cart-icon-bubble.js';
import './cart-drawer.js';
import './line-item.js';
import './dev-remark.js';
import './preview-return.js';

initRouter();

// Re-open the native consent preferences dialog from any "Manage cookie
// preferences" control (footer privacy button, cookies-settings page). Delegated
// on document so it survives Turbo body swaps and works for section-rendered
// markup.
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.js-manage-cookie-preferences');
  if (!trigger) return;
  event.preventDefault();
  consent.showPreferences();
});

log('[App] entry-default loaded');

if (window.ep_appinfo && window.ep_appinfo.theme) {
  const t = window.ep_appinfo.theme;
  log('[Theme]', t.name, { id: t.id, name: t.name, role: t.role });
}
